import Vue from 'vue'
function objKeySort (obj) {//排序的函数
  //先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
  let newkey = Object.keys(obj).sort()
  let newObj = {};//创建一个新的对象，用于存放排好序的键值对
  for (let i = 0; i < newkey.length; i++) {//遍历newkey数组
    newObj[newkey[i]] = obj[newkey[i]]//向新创建的对象中按照排好的顺序依次增加键值对
  }
  return newObj//返回排好序的新对象
}
/**
 *
 * @param price 价格
 * @returns 价格格式化
 */
function priceFormat (price, lang) {
  let str = String(price)
  let newPrice = ''
  if (lang === 'zh') {
    newPrice = str.length > 4 ? toFixed(price, 10000) + '万' : str
  } else {
    newPrice =
      str.length > 6
        ? toFixed(price, 1000000) + 'M'
        : str.length > 3 && str.length <= 6
          ? toFixed(price, 1000) + 'K'
          : str
  }
  return newPrice
}
function toFixed (price, divisor) {
  if (price > 0) {
    if (price % divisor === 0) {
      return price / divisor
    } else if (
      (price / divisor).toFixed(2) ==
      (price / divisor).toFixed(1) + '0'
    ) {
      return (price / divisor).toFixed(1)
    } else {
      return (price / divisor).toFixed(2)
    }
  } else {
    return 0
  }
}
function capitalizeAndRemoveUnderscore (string) {
  console.log(string)
  if (string) {
    return string
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  }
}
Vue.prototype.$objKeySort = objKeySort;
Vue.prototype.$priceFormat = priceFormat;
Vue.prototype.$capitalizeAndRemoveUnderscore = capitalizeAndRemoveUnderscore;



// WEBPACK FOOTER //
// ./src/util/common.js